export default __webpack_public_path__ + "static/media/globe.99aa01ac.svg";